<template>
    <div class="tabs-layout">
        <md-tabs @md-changed="changeTab" md-active-tab="tab-not-processed">
            <md-tab v-for="tab in tabs" :key="tab.id" :id="tab.id" :md-label="tab.tabTitle">
                <demand-card :title="tab.title" :active="tab.active" :payload="tab.payload" :action="tab.action"
                             :icon="tab.icon" :color="tab.color" :search="tab.search"></demand-card>
            </md-tab>
        </md-tabs>
    </div>
</template>

<script>
import DemandCard from "@/pages/Demands/components/DemandCard";

export default {
    name: "Demands",
    components: { DemandCard },
    data() {
        return {
            tabs: [
                {
                    id: 'tab-not-processed', title: 'Liste des demandes non traitées', icon: 'phone', color: { icon: 'danger', table: 'red', pagination: 'danger' },
                    tabTitle: 'Demandes non traitées', active: false, payload: { status: 0 }, action: true,
                },
                {
                    id: 'tab-in-progress', title: 'Liste des demandes en attente', icon: 'phone', color: { icon: 'warning', table: 'orange', pagination: 'warning' },
                    tabTitle: 'Demandes en attente', active: false, payload: { status: 10 }, action: false,
                },
                {
                    id: 'tab-processed', title: 'Liste des demandes traitées (250 dernières)', icon: 'phone', color: { icon: 'green', table: 'green', pagination: 'success' },
                    tabTitle: 'Demandes traitées', active: false, payload: { status: 1, limit: 250 }, action: false,
                },
                {
                    id: 'tab-without-client', title: 'Sans client affecté (500 dernières)', icon: 'phone', color: { icon: 'blue', table: 'blue', pagination: 'info' },
                    tabTitle: 'Sans client affecté', active: false, payload: { limit: 500, client: true }, action: false,
                },
                {
                    id: 'tab-search-v2', title: 'Recherche V2', icon: 'search', color: { icon: 'default', table: 'blue', pagination: 'info' },
                    tabTitle: 'Recherche V2', active: false, action: false, search: true
                },
            ],
        }
    },
    methods: {
        changeTab(id = 'tab-not-processed') {
            this.tabs.map(tab => tab.active = false)
            let activeTab = this.tabs.find(tab => tab.id === id)
            if(activeTab) activeTab.active = true
        },
    },
}
</script>

<style scoped lang="scss">
#tab-new-demand {
    .md-layout {
        .md-layout-item:first-child {
            padding-left: 0 !important;
        }
        .md-layout-item:last-child {
            padding-right: 0 !important;
        }
    }
}
</style>
